// This config contains NAME-SPACE for each module of ENDPOINTS config
export const ModulesMap = {
	LAND_DOCUMENT_TYPES: 'land_document_types',
	LAND_DOCUMENTS: 'land_documents',
	EQUIPMENT_REGISTRATIONS: 'equipment_registrations',
	EQUIPMENT_FACTPLACES: 'equipment_factplaces',
	INCIDENT_TAGS: 'incident_tags',
	INCIDENT_COMMENTS: 'incidents_comments',
	INCIDENTS: 'incidents',
	INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS: 'incidents_my_works_to_administrate_incidents',
	INSPECTION_REPORTS: 'inspection_reports',
	INSPECTION_REPORT_PROBLEMS: 'inspection_report_problems',
	INSPECTION_REPORT_MEASURES: 'inspection_report_measures',
	INSPECTION_REPORT_PROBLEM_ATTACHMENTS: 'inspection_report_problem_attachments',
	INSPECTION_TEMPLATES: 'inspection_templates',
	INSPECTION_PROBLEM_CATEGORIES: 'inspection_problem_categories',
	INSPECTION_PROBLEMS: 'inspection_problems',
	INSPECTION_MEASURE_CATEGORIES: 'inspection_measure_categories',
	INSPECTION_MEASURES: 'inspection_measures',
	OPERATIONAL_MATERIALS: 'operational_materials',
	REGULATIONS_STAGES_PLAN_WORKS_QUALITI_CONTROLS: 'regulations_stages_plan_works_qualiti_controls',
	REGULATIONS_STAGES_PLAN_WORKS_SERVICE_PAYMENTS: 'regulations_stages_plan_works_service_payments',
	REGULATIONS_STAGES_PLAN_WORKS_STAFF_PAYMENTS: 'regulations_stages_plan_works_staff_payments',
	REGULATIONS_STAGES_PLAN_WORKS_STAFF_GROUPS: 'regulations_stages_plan_works_staff_groups',
	REGULATIONS_STAGES_PLAN_WORKS_PRODUCTS: 'regulations_stages_plan_works_products',
	REGULATIONS_STAGES_PLAN_WORKS_MATERIALS: 'regulations_stages_plan_works_materials',
	WORK_REPORT_DOCUMENTS: 'work_report_documents',
	REGULATIONS_STAGE_TAGS: 'regulation_stage_tags',
	WORKS_SERVICE_PAYMENT_RATE_NORMS: 'works_service_payment_rates_norms',
	WORKS_MATERIAL_PRODUCTION_RATE_NORMS: 'works_materials_production_norms',
	MAPS: 'maps',
	TRIPS: 'trips',
	POSITION_DEVICES: 'positionDevices',
	WORKS_COST_CATEGORIES: 'works_cost_categories',
	REGULATION_TAGS: 'regulation_tags',
	EQUIPMENT_GROUPS: 'equipment_groups',
	STAFF_GROUPS: 'staff_groups',
	STAFF_DEPARTMENTS: 'staff_departments',
	STAFF_AND_MACHINERY_CARDS: 'staff_and_machinery_cards',
	CACHE: 'cache',
	USER: 'user',
	COMPANY: 'company',
	COMPANY_FUEL_SETTINGS: 'company_fuel_settings',
	FIELDS: 'fields',
	AUTH: 'auth',
	PRESETS: 'presets',
	MACHINES: 'machines',
	STAFF: 'staff',
	EQUIPMENT: 'equipment',
	INFRASTRUCTURES: 'infrastructures',
	INFRASTRUCTURE_TYPES: 'infrastructure_types',
	INFRASTRUCTURE_DOCUMENTS: 'infrastructure_documents',
	INFRASTRUCTURE_PLEDGES: 'infrastructure_pledges',
	INFRASTRUCTURE_REGISTRATIONS: 'infrastructure_registrations',
	INFRASTRUCTURE_TAGS: 'infrastructures_tags',
	INFRASTRUCTURE_PHOTOS: 'infrastructure_photos',
	LEGAL_ENTITIES: 'legal_entities',
	DEVICES: 'devices',
	SENSORS: 'sensors',
	DEVICE_MOUNTS: 'device_mounts',
	CLUSTERS: 'field_clusters',
	WEIGHT_STATIONS: 'weight_stations',
	PARTNERS: 'partners',
	AGGREGATE_CARDS: 'aggregate_cards',
	MATERIALS: 'materials',
	MATERIALS_CATEGORIES: 'materials_categories',
	MATERIALS_TAGS: 'materials_tags',
	FIELDS_TAGS: 'fields_tags',
	GPS_SOURCES: 'gps_sources',
	IDENTITY_CARDS: 'identity_cards',
	IDENTITY_MOUNTS: 'identity_mounts',
	MACHINES_GROUPS: 'machine_groups',
	STAFF_ROLES: 'staff_roles',
	MACHINE_FUEL_TANKS: 'fuel_tanks',
	MACHINE_BRIGADE: 'brigade',
	MACHINE_DOCUMENTS: 'documents',
	MACHINE_PHOTOS: 'photos',
	MACHINE_PLEDGES: 'pledges',
	MACHINE_TRANSFERS: 'transfers',
	COUNTERPARTIES: 'counterparties',
	COUNTERPARTIES_GROUPS: 'counterparties_groups',
	FUEL: 'fuel',
	FUEL_STATIONS: 'fuel_stations',
	FUEL_STATION_EVENTS: 'fuel_station_events',
	FUEL_STATION_RAW_EVENTS: 'fuel_station_raw_events',
	FUEL_STATION_GUNS: 'fuel_station_guns',
	WORKS_CATEGORIES: 'works_categories',
	WORKS: 'works',
	WORKS_MATERIAL_CONSUMPTION_RATE_NORMS: 'works_materials_consumption_norms',
	WORKS_PRODUCTIVITY_NORMS: 'works_productivity_norms',
	WORKS_QUALITY_NORMS: 'works_quality_norms',
	REGULATIONS_APPLICATION_AREA: 'regulations_application_area',
	CROPS: 'crops',
	WORKS_STAFF_PAYMENT_RATES_NORMS: 'works_staff_payment_rates_norms',
	POSITIONS_MACHINES: 'positions_machines',
	EVENTS: 'events',
	EQUIPMENT_PHOTOS: 'equipment_photos',
	WORK_REPORT_MEASURES: 'work_report_measures',
	WORK_REPORT_PHOTOS: 'work_report_photos',
	WORK_REPORT_LINKS: 'work_report_links',
	REGULATIONS_TARGET_PRODUCTS: 'regulations_target_products',
	REGULATIONS_METRICS: 'regulations_metrics',
	REGULATIONS_STAGES: 'regulations_stages',
	REGULATIONS_STAGES_PLAN_WORKS: 'regulations_stages_plan_works',
	MATERIALS_PHOTOS: 'materials_photos',
	MATERIALS_COSTS: 'materials_costs',
	FINANCE_GROUPS: 'finance_groups',
	FINANCE_CATEGORIES: 'finance_categories',
	FINANCE_TAGS: 'finance_tags',
	BUSINESS_PROCESSES: 'business_processes',
	BUSINESS_PROCESS_ASSESSMENTS: 'business_process_assessments',
	NOTIFICATIONS: 'notifications',
	REGULATION_BASE_FINANCE_ATTRIBUTION: 'regulation_base_finance_attribution',
	REGULATION_PLAN_WORK_FINANCE_ATTRIBUTION: 'regulation_plan_work_finance_attribution',
	REPORTS: 'reports',
	REPORTS_DONE_WORKS_COSTS: 'reports_done_works_costs',
	REPORTS_DONE_WORKS: 'reports_done_works',
	REPORTS_MANUFACTURED_MATERIALS: 'reports_manufactured_materials',
	REPORTS_QUALITY_CONTROLS: 'reports_quality_controls',
	REPORTS_SERVICE_PAYMENTS: 'reports_service_payments',
	REPORTS_STAFF_PAYMENTS: 'reports_staff_payments',
	REPORTS_FINANCE_BY_CATEGORIES: 'reports_finance_by_categories',
	REPORTS_FINANCE_BY_DESTINATION: 'reports_finance_by_destination',
	REPORTS_FINANCE_BY_WORK_TYPE: 'reports_finance_by_work_type',
	REPORTS_FINANCE_EFFICIENCY: 'reports_finance_efficiency',
	REPORTS_FINANCE_PRODUCTS: 'reports_finance_products',
	REPORTS_STAGES_PROGRESS: 'reports_stages_progress',
	REPORTS_STAGES_PROGRESS_WITH_WORKS: 'reports_stages_progress_with_works',
	REPORTS_FINANCE_BY_MATERIALS_CATEGORIES: 'reports_finance_by_materials_categories',
	REPORTS_FINANCE_BY_ROLES: 'reports_finance_by_roles',
	REPORTS_FINANCE_BY_SERVICES: 'reports_finance_by_services',
	REPORTS_FINANCE_BY_WORK_CATEGORIES: 'reports_finance_by_work_categories',
	DONE_WORKS_BRIGADE: 'done_works_brigade',
	DONE_WORKS_CALCULATION_VOLUME_METRICS: 'done_works_calculation_volume_metrics',
	DONE_WORKS_DOCUMENTS: 'done_works_documents',
	DONE_WORKS_FINANCE_ATTRIBUTION: 'done_works_finance_attribution',
	DONE_WORKS_LINKS: 'done_works_links',
	DONE_WORKS_MEASURES: 'done_works_measures',
	DONE_WORKS_PHOTOS: 'done_works_photos',
	DONE_WORKS: 'done_works',
	DONE_WORKS_CONTROL_METRICS: 'done_works_control_metrics',
	REGULATIONS: 'regulations',
	REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_MACHINES:
		'regulations_stages_plan_works_recomended_machines',
	REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT:
		'regulations_stages_plan_works_recomended_equipment',
	REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_COUNTERPARTIES:
		'regulations_stages_plan_works_recomended_counterparties',
	REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_STAFF: 'regulations_stages_plan_works_recomended_staff',
	REGULATIONS_FINANCE_PRODUCTIVITY: 'regulations_finance_productivity',
	REPORTS_REPORTING: 'reportsReporting',
	REGULATION_STAGE_FINANCE_ATTRIBUTION: 'regulation_stage_finance_attribution',
	DONE_WORKS_MANUFACTURED_MATERIALS: 'done_works_manufactured_materials',
	DONE_WORKS_OPERATIONAL_MATERIALS: 'done_works_operational_materials',
	DONE_WORKS_SERVICES: 'done_works_services',
	DONE_WORKS_CALCULATION_MATERIALS_METRICS: 'done_works_calculation_materials_metrics',
	DONE_WORKS_IN_PROGRESS_FIELD_WORKS: 'done_works_in_progress_field_works',
	BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS: 'business_processes_active_plan_works',
	RULES_BREAKING: 'rules_breaking',
	WORK_ORDERS: 'work_orders',
	WORK_ORDERS_MATERIALS: 'work_orders_materials',
	WORK_ORDERS_PRODUCTS: 'work_orders_products',
	WORK_ORDERS_QUALITY_CONTROLS: 'work_orders_quality_control',
	DONE_WORKS_DONE_FIELD_WORKS: 'done_work_done_field_works',
	WEIGHT_TRANSACTIONS: 'weight_transactions',
	WEIGHING_COMBINER_TICKETS: 'weighing_combiner_tickets',
	CROP_WRITEOFFS: 'crop_writeoffs',
	MACHINERY_WRITEOFFS: 'machinery_writeoffs',
	DONE_WORKS_MY_WORKS_TO_ADMINISTRATE: 'done_works_my_works_to_administrate',
	DONE_WORKS_MY_WORKS_TO_CONTROL: 'done_works_my_works_to_control',
	DONE_WORKS_MY_WORKS_TO_DO: 'done_works_my_works_to_do',
	WORKS_SHIFT: 'works_shifts',
	ORDER_GENERATORS_FIELDS_WORKS: 'order_generators_fields_works',
	ORDER_GENERATORS_FIELDS_WORKS_PLAN_WORKS: 'order_generators_fields_works_plan_works',
	ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS: 'order_generators_fields_works_executors',
	ORDER_GENERATORS_FIELDS_WORKS_EXECUTORS_BRIGADES:
		'order_generators_fields_works_executors_brigades',
	ORDER_GENERATORS_FIELDS_WORKS_MATERIALS: 'order_generators_fields_works_materials',
	ORDER_GENERATORS_FIELDS_WORKS_PRODUCTS: 'order_generators_fields_works_products',
	ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS: 'order_generators_fields_works_quality_controls',
	ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS: 'order_generators_fields_works_staff_payments',
	ORDER_GENERATORS_FIELDS_WORKS_SERVICES: 'order_generators_fields_works_services',
	MACHINE_REGISTRATIONS: 'machine_registrations',
	MACHINE_FACT_PLACES: 'machine_fact_places',
	LOGISTIC_ROUTES: 'logistic_routes',
	LOGISTIC_ROUTE_TAGS: 'logistic_tags',
	LOGISTIC_ROUTES_GEO_ZONES: 'logistic_routes_geo_zones',
	REPORT_DEVICE_MOUNTS: 'report_device_mounts',
	DONE_WORKS_ALL_FIELD_WORKS: 'done_works_all_field_works',
	DONE_WORKS_ALL_LOGISTIC_WORKS: 'done_works_all_logistic_works',
	DONE_WORKS_ALL_HAND_MADE_WORKS: 'done_works_all_hand_made_works',
	REGULATIONS_ALL_PLAN_WORKS: 'regulations_all_plan_works',
	MACHINES_ICONS: 'machine_icons',
	CARGOS: 'cargos',
	CARGO_ITEMS: 'cargo_items',
	CARGO_TAGS: 'cargo_tags',
	API_USAGES: 'api_usages',
	LANDS: 'lands',
	LAND_PLEDGES: 'land_pledges',
	LAND_ACTIONS: 'land_actions',
	LAND_CATEGORIES: 'land_categories',
	LAND_OWNERSHIP_TYPES: 'land_ownership_types',
	LAND_PURPOSES: 'land_purposes',
	EQUIPMENT_DOCUMENTS: 'equipment_documents',
	EQUIPMENT_PLEDGES: 'equipment_pledges',
	LANDS_CADASTRAL_CASES: 'land_cadastral_cases',
	CUSTOM_GEO_ZONES: 'custom_geo_zones',
	CUSTOM_GEO_ZONES_CATEGORIES: 'custom_geo_zones_categories',
	BUSINESS_PROCESS_BASE_EXECUTORS: 'business_process_base_executors',
	BUSINESS_PROCESS_RECOMMENDATIONS: 'business_process_recommendations',
	ELEVATORS_WAYBILL_REGISTERS: 'elevators_waybill_registers',
	ELEVATORS_INVENTORY_BALANCE_LINES: 'elevators_inventory_balance_lines',
	ELEVATORS_OPERATIONS: 'elevators_operations',
	ELEVATORS_LABORATORY_ANALYSES: 'elevators_laboratory_analyses',
	GRAIN_YARD_BALANCE_LINES: 'grain_yard_balance_lines',
}

// This config contains whole only ENDPOINTS and MOCK Config SCHEMA
export const ModulesConfigMap = {
	[ModulesMap.LAND_DOCUMENT_TYPES]: {
		GET_LAND_DOCUMENT_TYPES: 'getLandDocumentTypes',
		GET_LAND_DOCUMENT_TYPE: 'getLandDocumentType',
		GET_LAND_DOCUMENT_TYPE_PREVIEW: 'getLandDocumentTypePreview',
		GET_LAND_DOCUMENT_TYPE_POPUP: 'getLandDocumentTypePopup',
		CREATE_LAND_DOCUMENT_TYPE: 'createLandDocumentType',
		PUT_LAND_DOCUMENT_TYPE: 'putLandDocumentType',
		PATCH_LAND_DOCUMENT_TYPE: 'patchLandDocumentType',
		DELETE_LAND_DOCUMENT_TYPE: 'deleteLandDocumentType',
	},
	[ModulesMap.WORK_REPORT_DOCUMENTS]: {
		GET_WORK_REPORT_DOCUMENTS: 'getWorkReportDocuments',
		GET_WORK_REPORT_DOCUMENT: 'getWorkReportDocument',
		CREATE_WORK_REPORT_DOCUMENT: 'createWorkReportDocument',
		PUT_WORK_REPORT_DOCUMENT: 'putWorkReportDocument',
		PATCH_WORK_REPORT_DOCUMENT: 'patchWorkReportDocument',
		DELETE_WORK_REPORT_DOCUMENT: 'deleteWorkReportDocument',
	},
	[ModulesMap.CACHE]: {
		GET_CACHE_HASHES: 'getCashHashes',
	},
	[ModulesMap.USER]: {
		GET_DATA: 'getData',
		GET_PERMISSIONS: 'getPermissions',
		GET_POPULATION: 'getPopulation',
		GET_CACHE_VERSION: 'getCahceVersion',

		GET_CURRENT_USER: 'getCurrentUser',
		GET_AVAILABLE_COMPANIES: 'fetchAvailableCompanies',

		PUT_USER: 'putUser',
		PATCH_USER: 'patchUser',
		SET_PASSWORD: 'setPassword',
	},
	[ModulesMap.COMPANY]: {
		CREATE_COMPANY: 'createCompany',
		GET_COMPANY: 'getCompanyProfileById',
		PATCH_COMPANY: 'patchCompany',
		GET_AVAILABLE_USER_COMPANY_PERMISSIONS: 'getAvailableUserCompanyPermissions',
	},
	[ModulesMap.AUTH]: {
		REGISTER_USER: 'registerUser',
		LOGIN_USER: 'loginUser',
		RESEND_EMAIL_CONFIRMATION: 'resendEmailConfirmation',
	},
	[ModulesMap.PRESETS]: {
		GET_PRESETS: 'getPresets',
		GET_MULTIPLE_PRESETS: 'getMultiplePresets',
		DELETE_PRESET: 'deletePreset',
		EDIT_PRESET: 'editPreset',
		PATCH_PRESET: 'patchPreset',
		CREATE_PRESET: 'createPreset',
		CLONE_TO_COMPANY_PRESET: 'cloneToCompanyPreset',
		CHANGE_PRESETS_ORDER: 'changePresetsOrder',
	},
	[ModulesMap.MAPS]: {
		GET_MAPS_TELEMATIC_CHART_DATA: 'getMapsTelematicChartData',
		GET_MAPS_CROPS: 'getMapsCrops',
		GET_MAPS_CROPS_EXTENDED_INFO: 'getMapsCropsExtendedInfo',
		GET_MAPS_EVENTS: 'getMapsEvents',
		GET_MAPS_MOVEMENT_POINTS: 'getMapsMovementPoints',
		GET_MAPS_TRACKS: 'getMapsTracks',
		GET_MAPS_TRACKS_EXTENDED_INFO: 'getMapsTracksExtendedInfo',
		GET_MAPS_TRACKS_MOVED_MACHINES: 'getMapsTracksMovedMachines',
		GET_MAPS_TRACKS_REALTIME_DATA: 'getMapsTracksRealtimeData',
		GET_MAPS_FIELD_WORKS: 'getMapsFieldWorks',
		GET_MAPS_LOGISTIC_WORKS: 'getMapsLogisticWorks',
		GET_MAPS_PREVIEW: 'getMapsPreview',
		GET_MACHINE_TRACK: 'getMachineTrack',
		GET_RELATED_FIELD_WORKS: 'getRelatedFieldWorks',
		GET_MACHINE_WIDE_TRACK: 'getMachineWideTrack',
		GET_MACHINE_WIDE_TRACK_CROSSED_CROPS: 'getMachineWideTrackCrossedCrops',
		GET_MACHINE_TRACK_POINTS: 'getMachineTrackPoints',
		GET_SATELLITE_IMAGE_DATES: 'getSatelliteImageDates',
		GET_SATELLITE_IMAGE_DATE_DYNAMIC: 'getSatelliteImageDateDynamic',
		GET_SATELLITE_IMAGES: 'getSatelliteImages',
		GET_SATELLITE_IMAGE: 'getSatelliteImage',
		GET_SATELLITE_IMAGES_STATS: 'getSatelliteImagesStats',
		GET_DONE_WORK_GEOMETRIES: 'getDoneWorkGeometries',
	},
	[ModulesMap.STAFF]: {
		GET_AVAILABLE_STAFF: 'getAvailableStaff',
		CREATE_STAFF: 'createStaff',
		GET_STAFF: 'getStaff',
		GET_STAFF_POPUP: 'getStaffPopup',
		GET_STAFF_PREVIEW: 'getStaffPreview',
		PATCH_STAFF: 'patchStaff',
		PUT_STAFF: 'putStaff',
		DELETE_STAFF: 'deleteStaff',
		SET_PERMISSION: 'setPermission',
	},
	[ModulesMap.WORK_REPORT_MEASURES]: {
		GET_WORK_REPORT_MEASURES: 'getWorkReportMeasures',
		CREATE_WORK_REPORT_MEASURE: 'createWorkReportMeasure',
		GET_WORK_REPORT_MEASURE: 'getWorkReportMeasure',
		PUT_WORK_REPORT_MEASURE: 'putWorkReportMeasure',
		PATCH_WORK_REPORT_MEASURES: 'patchWorkReportMeasures',
		DELETE_WORK_REPORT_MEASURE: 'deleteWorkReportMeasure',
	},
}

// This config contains data generation METHODS NAMES
// for specific module
export const MockMethodsMap = {
	[ModulesMap.CACHE]: {
		GET_CACHE_HASHES: 'generateCashHashes',
	},
	[ModulesMap.USER]: {
		GET_CURRENT_USER: 'generateCurrentUser',
		GET_PERMISSIONS: 'generateUserPermissions',
	},
	[ModulesMap.AUTH]: {
		LOGIN: 'login',
		REGISTER: 'register',
		LOGOUT: 'logout',
	},
	[ModulesMap.PRESETS]: {
		GET_PRESETS: 'getPresetes',
		RESTORE_BASE_PRESETS: 'restoreBasePresets',
		DELETE_PRESET: 'deletePreset',
		EDIT_PRESET: 'editPreset',
		CREATE_PRESET: 'createPreset',
		CHANGE_PRESETS_ORDER: 'changePresetsOrder',
	},
}
